<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">

            <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                <li class="pr-3"><a class="cursor-pointer">Help</a></li>
                <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Survey</a></li>
            </ul>

            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello!</h2>

                    <h3>
                        We would love your feedback.
                    </h3>

                    <h3>#1 :: Ability to Create New Clients using the Member Benefit Check</h3>

                    <div class="flex flex-column gap-2">
                        <div class="field flex align-items-center gap-2 mb-4">
                            <Button label="Close" icon="pi pi-user" class="w-full" :loading="submitted"
                                    @click="processOverview"></Button>
                        </div>


                        <div class="field">
                            <Rating v-model="ratingValue" />
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import userService from "@/service/UserService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;

            // if (this.userConfiguration.showWelcome === 'Y') {
            //    this.skipWelcome = false;
            // } else {
            //    this.skipWelcome = true;
            // }


        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }
    },
    data() {

        return {
            profile: {},
            submitted: false,
            skipWelcome: true,
            userConfiguration: {},
            ratingValue: null
        }
    },
    methods: {
        processBookAppointment() {
            window.open("https://kitrin.com/book-appointment", '_blank');
        },
        async processOverview() {
            this.userConfiguration.showSurvey = 'N';
            await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);

            setTimeout(() => {
                this.$router.push("healthOverviewHome");
            }, 0);
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
